<!-- 这是传入图片，当作背景的操作 -->
<template>
  <div :style="computedStyle" class="tx-item-container">
    <slot></slot>
  </div>
</template>
<script setup>
import config from '@img/config.json';
const { support_image } = inject('GlobalStore');
import px2vw from '../utils/px2vw';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  size: {
    type: Object,
    required: false
  }
});
const bg = ref();
const computedStyle = computed(() => {
  var size = null
  if (props.size) {
    size = props.size
  } else {
    size = config[props.src];
  }
  return {
    backgroundImage: `url(${bg.value})`,
    width: size.width + 'px',
    height: size.height + 'px',
  };
});

onMounted(async () => {
  let src = config[props.src].src;
  bg.value = `${src}.${support_image.value}`;
});
</script>
<style scoped>
.tx-item-container {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;
}
</style>
